module.exports = "#define GLSLIFY 1\nvarying vec2 vUv;\n\nvoid main() {\n  vUv = uv;\n  gl_Position = vec4(position, 1.);\n}"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/passThrough.vert
// module id = 56
// module chunks = 0